export const FREESPIN_STATUS = {
  ACTIVATION_READY: 'ACTIVATION_READY',
  ACTIVATED: 'ACTIVATED',
  CANCELED: 'CANCELED',
  DISABLED: 'DISABLED',
  EXPIRED: 'EXPIRED',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  USED: 'USED',
};

const KNOWN = new Set(Object.values(FREESPIN_STATUS));

export const isKnownFreespinStatus = status => KNOWN.has(status);

export const isFreespinShownInProfileList = status => status !== FREESPIN_STATUS.DISABLED;

export const canPlayFreespin = status => status === FREESPIN_STATUS.ACTIVATED;

export const canCancelFreespin = status => status === FREESPIN_STATUS.ACTIVATED;
